/* RESPONSIBLE TEAM: team-data-foundations */
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import Fragment from 'ember-data-model-fragments/fragment';
import Admin from 'embercom/models/admin';
import type ActionResponse from './action-response';

export default class CodeBlockExecutionTestResult extends Fragment {
  @attr('number') declare adminId: number;
  @attr('date') declare createdAt: Date;
  @attr('date') declare updatedAt: Date;
  @fragment('workflow-connector/action-response') declare response: ActionResponse;

  get admin() {
    return Admin.peekAndMaybeLoad(this.store, this.adminId?.toString());
  }
}
